export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/services", label: "Services", hasDropdown: true },
  { href: "/insights", label: "Insights Hub", hasDropdown: true }, 
];

export const insightsLinks = [
  { label: "Blog", href: "/blog" },
  { label: "Media", href: "/media" },
  // { label: "Resources", href: "/resources" },
];

export const serviceLinks = [
  { href: "/services/tax-advisory-planning", label: "Tax Advisory & Planning" },
  { href: "/services/tax-returns-filing", label: "Tax Returns Preparation & Filing" },
  { href: "/services/kra-audit-support", label: "KRA Audit Support & Dispute Resolution" },
  // { href: "/services/tax-compliance-health-check", label: "Tax Compliance Health Check" },
  { href: "/services/bookkeeping-accounting", label: "Bookkeeping & Accounting" },
  { href: "/services/payroll-management", label: "Payroll Management & PAYE Compliance" },
  { href: "/services/business-registration", label: "Business Registration & Start-Up Support" },
  // { href: "/services/advisory-growth-strategy", label: "Advisory for Growth & Strategy" },
  { href: "/services/corporate-training", label: "Corporate Training & Workshops" },
];

export const values = [
  {
    title: "Integrity",
    description:
      "We give honest advice, even when it's not what you hoped to hear. Your trust is the foundation of everything we do.",
  },
  {
    title: "Excellence",
    description:
      "We hold ourselves to the highest professional standards in every return filed, every opinion given, and every engagement delivered.",
  },
  {
    title: "Confidentiality",
    description:
      "Your financial information is sensitive. We protect it with strict confidentiality protocols on every engagement, formalized through NDAs.",
  },
  {
    title: "Partnership",
    description:
      "We don't disappear after the invoice. We walk with our clients for the long term, through every tax season and every stage of growth.",
  },
  {
    title: "Clarity",
    description:
      "We translate complex tax law into plain language, so you always understand your position and your options.",
  },
];

export const whyChoose = [
  {
    num: "01",
    title: "Deep EAC Tax Expertise",
    description:
      "We live and breathe the EAC tax environment — the Finance Acts, KRA practice, iTax, eTIMS — and we stay ahead of every change so you don't have to.",
  },
  {
    num: "02",
    title: "Tailored Solutions",
    description:
      "No two businesses are alike. Our advice is built around your industry, your size, and your goals — never copy-pasted templates.",
  },
  {
    num: "03",
    title: "Responsive & Accessible",
    description:
      "When tax authorities send a demand letter, you can't wait a week for a callback. We pride ourselves on fast, dependable communication.",
  },
  {
    num: "04",
    title: "A True Long-Term Partner",
    description:
      "Our process doesn't end at delivery. We provide ongoing support, proactive updates, and continuous guidance as your business evolves.",
  },
];